import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsActive = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <g fill="currentColor">
        <polygon points="21.8858928 2.5833333 8.0899397 17.7435514 2.006673 11.5703809 .2511628 13.3798119 8.1544753 21.4166667 23.7488372 4.2845903 21.8858928 2.5833333" />
      </g>
    </SvgIcon>
  );
});

export default AppIconsActive;
